import { Heading } from '@components/rolex-ui/Heading'
import { getRcpoModelPrimaryAttributes } from '../../../../lib/get-rcpo-model-primary-attributes'
import { Article } from '@generated'
import { formatPrice } from '@lib/formatPrice'
import { useTranslation } from 'next-i18next'
import React, { FC } from 'react'
import { Text } from '@components/rolex-ui/Text'
import { cn } from '@lib/cn'
import { RCPO_ATTRIBUTE_ID_COLLECTION } from '@components/_rcpo/ProductOverview/hooks/use-rcpo-data'

type BasicInfoProps = {
  data: Article
}

export const BasicInfo: FC<BasicInfoProps> = ({ data }) => {
  const { t } = useTranslation('rolex')
  const primaryAttributes = getRcpoModelPrimaryAttributes(data)
  const collectionName = data.articleAttributes.find(
    (attr) => attr.attributeID === RCPO_ATTRIBUTE_ID_COLLECTION,
  )?.attributeValue

  return (
    <>
      <h1>
        <Text as="span" variant="body24" className="mb-2 block text-current">
          Rolex Certified Pre-Owned
        </Text>
        <Heading as="span" variant="headline50" className="mb-[10px] text-current">
          {collectionName ?? data.modelName}
        </Heading>
        <Text variant="body20" weight="light" className="block text-current">
          {primaryAttributes}
        </Text>
      </h1>
      <Text
        variant="body20"
        weight="light"
        className={cn('mb-[30px] block text-current', 'md:mb-[10px]', 'lg:mb-5')}
      >
        {data.supplierNr && `${t('specs.reference')}: ${data.supplierNr}`}
      </Text>
      {data.supplierNr && (
        <Text variant="body20" weight="light" className="block text-current">
          {t('detail.price')}:<span className="font-bold"> {formatPrice(data?.price || 0)}</span>{' '}
          {t('detail.vat')}
        </Text>
      )}
    </>
  )
}
